export default __webpack_public_path__ + "static/media/halonasoft-logotype-l.06443ae5.svg";